module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	
	fox.registerWidget('LiveshowCounterBanner', {

		configure: function () {
			this.registerOptions('', {
				autoRender: false,
				customizeCounter: true,
				customizeCounterShort: false,
				dontReuseSn: true,
				widgets: {
					timer: {
						widget: 'JQTimer',
						autoRender: false,
						'handleWom.timerStopHandler.callback': '@parent:checkLsStatus',
						'handleWom.addedToDom': {
							widget: '@this',
							event: 'addedToDom',
							callback: '@parent:customizeCounter'
						}
					},
					checkLsApi: {
						widget: 'Api',
						method: 'Liveshow.getStarted',
						sendTimezone: true,
						'handleWom.checkLsApiRes': {
							event: ['success', 'error', 'failure', 'false'],
							widget: '@this',
							callback: '@parent:checkLsApiRes'
						}
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this._readyToRender = false;
			this.ls = fox.utils.localStorage;
		
			this.callParent('init', arguments);
		},

		running: function () {
			this.checkLsStatus();
			this.callParent('running', arguments);
		},

		checkLsStatus: function () {
			this.rwom1('#checkLsApi').send({}, false);
			return this;
		},

		rendering: function () {
			this.setTemplateOptions(this.tplOptions);
			this.callParent('rendering', arguments);
		},

		addedToDom: function () {
			return this.renderCounter();
		},

		activate: function () {
			this.checkLsStatus();
			this.callParent('activate', arguments);
		},

		isActualStartDate: function () {
			return new Date(this.tplOptions.addVars.startDate).getTime() - new Date().getTime() > 0;
		},

		renderCounter: function () {
			return this.rwom1('#timer').counterStart(fox.utils.getRemainingTime(this.tplOptions.addVars.startDate));
		},

		checkLsApiRes: function (res) {
			res = res.answer;
			
			if (res.response == false || !res.response.addVars.startDate || res.response.success.status == 'no_liveshow') {
				this.removeFromDom();
				return;
			}

			if (res.status === true
				&& res.response.success
				&& res.response.success.status === 'next_liveshow') {
				this.ls('setItem', '_lls_', [res.response.addVars.id, new Date(res.response.addVars.startDate).getTime() + 1000 * 60 * 30].join('_'));

				this.tplOptions = res.response;
				this.tplOptions.googleCalendarLink = this.generateGoogleLink(res.response);
				this.render();
			}
		},

		generateGoogleLink: function (resp) {
			var data = {};
			var startDate, finishDate, description;

			finishDate = fox.objectGet(resp, 'addVars.finishDate');

			if (!finishDate || (finishDate === '0000-00-00' || finishDate === '0000-00-00 00:00:00')) {
				finishDate = null;
			}

			if (startDate = fox.objectGet(resp, 'addVars.startDate')) {
				data['dates'] = fox.utils.dateFormat('%Y%m%dT%H%M%SZ', startDate);
			}

			data['dates'] = [data['dates'], fox.utils.dateFormat('%Y%m%dT%H%M%SZ', (finishDate || startDate))].join('/');

			if (title = fox.objectGet(resp, 'addVars.title')) {
				data['text'] = title + ': liveshow by ' + fox.getEnv('screenName');
			}

			if (description = fox.objectGet(resp, 'addVars.description')) {
				data['details'] = description;
			}

			data['location'] = [window.location.origin, 'liveshow'].join('/');

			return fox.utils.generateGoogleCalendarLink(data);
		},

		customizeCounter: function (obj, scope) {
			if (!this.getOption('customizeCounter')) {
				return;
			}

			var customizeCounterClass = this.getOption('customizeCounterClass') || '';
			var customizeCounterShort = this.getOption('customizeCounterShort');

			if (customizeCounterClass.length) {
				customizeCounterClass = ' class=' + customizeCounterClass;
			}

			obj = [
			{
				0: 'days',
				2: 'hours',
				4: 'minutes',
				6: 'seconds'
			},
			{
				0: 'days',
				2: 'hours',
				4: 'mins',
				6: 'secs'
			}];

			fox.each((customizeCounterShort ? obj[1] : obj[0]), function (val, key) {
				scope._counter.find('.part' + key).append('<div' + customizeCounterClass + '>' + val + '</div>');
			});
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/lsCounterBanner.js
// module id = 849
// module chunks = 4